import styled from "@emotion/styled";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { MDSLoadingIconSize } from "./loading-icon.types";

interface StyledLoadingIconProps {
  size: MDSLoadingIconSize;
}

const getSizeStyles = (size: MDSLoadingIconSize) => {
  switch (size) {
    case MDSLoadingIconSize.Small:
      return {
        width: "32px",
        height: "32px",
      };
    case MDSLoadingIconSize.Medium:
      return {
        width: "64px",
        height: "64px",
      };
    case MDSLoadingIconSize.Large:
      return {
        width: "88px",
        height: "88px",
      };
    default:
      return {
        width: "48px",
        height: "48px",
      };
  }
};

export const StyledLoadingIconContainer = styled.div<StyledLoadingIconProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${({ size }) => getSizeStyles(size)}
`;

export const StyledDotLottieReact = styled(DotLottieReact)`
  width: 100%;
  height: 100%;
`;
